<template>
  <div class="register-page">
    <div class="container">
      <div class="col-lg-6 offset-lg-3 col-md-12 offset-md-0 col-sm-12 offset-sm-0 container-register-page">
        <div class="text-center mt10 mb30">
          <img src="/static/ccall.png" class="logo-ccall" width="200" />
        </div>

        <form @submit.prevent="setNewPassword">
          <div class="form-header">{{$t('forgotPassword.header')}}</div>
          <div class="form-group">
            <span class="code-prefix">C - </span>
            <input type="number" pattern="[0-9]*" class="form-control form-code text-center" v-model="code" :placeholder="$t('forgotPassword.code')" :class="{'form-error': errorMessage['code']}" autocomplete="off" />
            <p v-for="msg in errorMessage['code']" class="text-error">{{msg}}</p>
          </div>

          <p v-if="resendCode" class="text-link text-center" @click="resetPassword()">{{$t('forgotPassword.resend')}}</p>
          <p v-if="!resendCode" class="text-link text-center disableResend">{{$t('forgotPassword.resend')}}</p>

          <div class="form-group">
            <input type="password" class="form-control text-center" v-model="password" :placeholder="$t('forgotPassword.password')" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" />
            <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
          </div>
          <div class="form-group text-center btn-submit">
            <base-button type="submit" class="btn-block" :disabled="code.length == 0 || password.length == 0 || isDisabled">{{$t('forgotPassword.next')}}</base-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import BaseButton from "../components/Button.vue";

  export default {
    components: {
      BaseButton
    },
    name: 'CreateNewPasswordPage',
    props: {
      phone: String,
      token: String,
      resendClick: Boolean
    },
    data() {
      return {
        code: '',
        password: '',
        errorMessage: [],
        isDisabled: false,
        resendCode: true
      };
    },
    methods: {
      resetPassword() {
        this.resendCode = false;
        this.isDisabled = true;
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        this.axios.post('/resetPassword', formData).then((response) => {
          if ((response.data.status)) {
            this.$router.push({name: 'CreateNewPasswordPage', params: {resendClick: false, phone: response.data.data.phone, token: response.data.data.token}})
          } else {
            this.isDisabled = false;
            this.errorMessage = response.data.data;
            this.resendCode = true;
          }
        })
      },
      setNewPassword() {
        this.isDisabled = true;
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('code', this.code);
        formData.append('token', this.token);
        formData.append('password', this.password);
        this.axios.post('/setNewPassword', formData).then((response) => {
          if ((response.data.status)) {
            top.window.location.href = "https://server.ccall.vn";
          } else {
            this.isDisabled = false;
            this.errorMessage = response.data.data;
            this.resendCode = true;
          }
        })
      }
    },
    mounted() {
      if(!this.resendClick) {
        this.resendCode = false;
        setTimeout(() => {
          this.resendCode = true;
        }, 60000);
      } else {
        this.resendCode = true;
      }
    }
  };
</script>
<style scoped="">
  .btn-block {
    width: 80% !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/CreateNewPasswordPage.vue